import { InitialAuthorizeTypes, initialAuthorizeState } from "./authorize";
import { InitialWorkspaceTypes, initialWorkspaceState } from "./workspace";

export type StoreState = {
  authorizeStore: InitialAuthorizeTypes;
  workspaceStore: InitialWorkspaceTypes;
};

export const initialState: StoreState = {
  authorizeStore: initialAuthorizeState,
  workspaceStore: initialWorkspaceState,
};
